import type { FaireProductEntity } from "../../entity_types/product";

export const p_tnh5rhpna5: FaireProductEntity = {
  token: "p_tnh5rhpna5",
  type: "product",
  name: "truth for today psalms cards",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/7ede65881948ff5d788aef31f16d514ce2297b7f18aa3ed39a9f8ece70061c3c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8aed9417bc5ff9ee265a158f3d07af3e6ac30ac08778576cc2d759993e6b216f.jpeg",
    "https://cdn.faire.com/fastly/c4a848b567d05f829e887fa7199758c21b3e5ed137606698b718b7a4a645e113.jpeg",
    "https://cdn.faire.com/fastly/981d8b60fb8d112681593189604d7cc477051a9573630b6040c112b4888ccec2.jpeg",
    "https://cdn.faire.com/fastly/77bac1fd5e15cde25a9c4f82893b482bce209583c1e6459a0bd26c309e159741.jpeg",
    "https://cdn.faire.com/fastly/d12a14bcf10e52905340832d566881b9101b77182f533d06c3c83123e5e2ba10.jpeg",
    "https://cdn.faire.com/fastly/65117d95fea97f9eb59e64b59df09d22505b50e0d1bad370e32afa2f9d1c5a78.jpeg",
    "https://cdn.faire.com/fastly/9b2ff51fa09a557eab9e03d37a45318078d50d7f0c6e0c6a7e7eb1b59780832f.jpeg",
    "https://cdn.faire.com/fastly/d3240e35c4ee1f4b5e3fd0fdb99c5b0cf3be7a80f0d615e54ad645c1938949a8.jpeg",
    "https://cdn.faire.com/fastly/03449e9664afc42a39971833f09209bae34c11cfde3f4fa664ccd98651b05797.jpeg",
  ],
  priceDollars: 17,
  description:
    '31 beloved Psalms paired with watercolor illustrations make for a lovely encouragement of beauty and truth. \n\nDisplay in your home for a pretty way to point to Jesus. Use them as daily or weekly memory verse reminders. Share them as encouragement with a friend. Easily used as gift tags, bookmarks, tiny notes, and more!\n\nDetails:\n\n- 31 card set\n- 4" x 4" square\n- 120lb cotton eggshell textured paper\n- Card stands sold separately\n\n',
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-28T05:30:12.217Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
